import React,{useState} from 'react'
import { Menu } from 'antd';
import { nav_menus } from '../../constant/index';
import './header.scss';

const MenuItem = Menu.Item;
const showOnlyOneNav=nav_menus.slice(-1);
function NavHeader(props) {
	const [activeKey, setActiveKey] = useState('');
	const menuClick = (e) => {
		setActiveKey(e.key);
	}
	return (
		<div className='nav_header'>
			{/* 只有最后一个导航显示的写法 */}
			<Menu
				onClick={menuClick}
				selectedKeys={[activeKey]}
				mode="horizontal"
				theme="light"
			>
				{
					showOnlyOneNav.map(({name,href},index) => <MenuItem key={name} className='custom_menu_item'>
						<a href={href} target='_blank'>{name}</a>
					</MenuItem>)
				}
			</Menu>
			{/* 五个导航按钮均居中显示写法 */}
			{/* <Menu
				onClick={menuClick}
				selectedKeys={[activeKey]}
				mode="horizontal"
				theme="light"
			>
				{
					nav_menus.map(({name,href},index) => <MenuItem key={name} className='custom_menu_item'>
						<a href={href} target='_blank'>{name}</a>
					</MenuItem>)
				}
			</Menu> */}

		</div>
	)
}

export default NavHeader
